import Component from '../abstracts/Component';
import { MobileBreakpoint, isMobile } from '../utils/MobileUtils';

export default class SeoTextComponent extends Component {

  get SELECTORS() {
    return {
      viewMoreButton: '[data-seo-text-more]',
      seoTextContent: '[data-seo-text-content]'
    }
  }

  get CLASSES() {
    return {
      full: 'full'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.viewMoreButton = this.$component.querySelector(this.SELECTORS.viewMoreButton);
    this.seoTextContent = this.$component.querySelector(this.SELECTORS.seoTextContent);
  }

  bindEvents() {
    if (isMobile(MobileBreakpoint.Max767)) {
      this.viewMoreButton.addEventListener('click', () => {
        this.seoTextContent.classList.add(this.CLASSES.full);
      });
    }
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
